import { useDispatch, useSelector } from 'react-redux';
import * as Styled from '../styles/ContasAprovados.styles';
import formatMoney from '../../../utils/functions/formatMoneyBRL';
import Button from '../../../components/Button/Button';
import Table from '../../../components/Table/Table';
import { FirstFilterLine, SecondFilterLine } from '../../../components/Filter/Filter.styles';
import Filter from '../../../components/Filter/Filter';
import { useEffect, useState, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import DateInput from '../../../components/DateInput';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../../components/SelectOptions';
import dotPrimary from '../../../assets/dotPrimary.svg';
import { userBalanceFetchAction } from '../../../store/fetchActions/usersActions';
import {
  balanceAccountsFetchAction,
  exportReceipt,
  detailAccountsFetchAction,
} from '../../../store/fetchActions/accountActions';
import { useTheme } from 'styled-components';
import moment from 'moment';
import { pagesOptions } from '../../../utils/constant';
import Loading from '../../../components/Loading';
import { Tooltip } from '@material-ui/core';
import { Comprovante } from '../../../assets/icon';
import TransferenciaAdmin from '../../../assets/icon/TransferenciaAdmin';
import ModalMakeTransfer from './Modals/MakeTransfer';
import RepaseLote from './Modals/RepaseLote';
import { Box, Checkbox, Skeleton } from '@mui/material';
import { showAlert } from '../../../store/ducks/sweetAlert';
import api from '../../../utils/services/api';
import Modal from '../../../components/Modal/Modal';

export default function GraphicSheet({ contas }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [saldo, setSaldo] = useState(0);
  const [makeTransfer, setMakeTransfer] = useState(false);
  const [valorTransacao, setValorTransacao] = useState(null);
  const [descricaoTransacao, setDescricaoTransacao] = useState(null);
  const [showComprovante, setShowComprovante] = useState(false);
  const [transactionSelected, setTransactionSelected] = useState([]);
  const [lodingComprovante, setLoadingComprovante] = useState(false);
  const [file, setFile] = useState(null);
  const [repaseLote, setRepaseLote] = useState(false);
  const [transacaoId, setTransacaoId] = useState(null);
  const [isRepasse, setIsRepasse] = useState(false);

  const [filterData, setFilterData] = useState({
    ID_CONTA: '',
    CPFCNPJ_CLIENTE: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    LIMIT: 10,
    PAGE: 1,
  });
  const [dateInicial, setDateInicial] = useState(null);
  const [dateFinal, setDateFinal] = useState(moment().format('YYYY-MM-DD'));

  const { handleSubmit, control } = useForm({});

  const {
    usersBalance: { HISTORICO, SALDO_ATUAL },
    errorUserBalance,
    loadingUserBalance,
    usersData,
  } = useSelector((state) => state.user);

  const filterTable = (data) => {
    data.DATA_INICIAL = dateInicial;
    data.DATA_FINAL = dateFinal;
    setFilterData(data);
  };

  useEffect(() => {
    const params = {
      ID_CONTA: contas?.ID_CONTA,
      CPFCNPJ_CLIENTE: usersData?.CPFCNPJ,
      DATAINICIAL: filterData.DATA_INICIAL,
      DATAFINAL: filterData.DATA_FINAL,
      LIMIT: filterData.LIMIT,
      PAGE: filterData.PAGE,
    };

    if (contas?.ID_CONTA !== undefined) {
      dispatch(userBalanceFetchAction(params));
    }
  }, [contas?.ID_CONTA, filterData]);

  const header = [
    {
      id: 'id',
      name: '',
      align: 'center',
    },
    {
      id: 'data da transferência',
      name: 'DATA DA TRANSFERÊNCIA',
      align: 'center',
    },
    { id: 'tipo', name: 'TIPO', align: 'left' },
    { id: 'descrição', name: 'DESCRIÇÃO', align: 'left' },
    { id: 'valor', name: 'VALOR', align: 'right' },
    { id: 'saldo anterior', name: 'SALDO ANTERIOR', align: 'right' },
    { id: 'saldo atual', name: 'SALDO ATUAL', align: 'right' },
    { id: 'acoes', name: 'AÇÕES', align: 'center' },
  ];

  const body = HISTORICO?.data?.map((operacao) => {
    return {
      data: [
        {
          info: (
            <Checkbox
              onChange={(event) => {
                event.stopPropagation();
                setTransactionSelected((prev) => {
                  if (event.target.checked) {
                    return [...prev, operacao.CODTRANSACAO];
                  } else {
                    return prev.filter((id) => id !== operacao.CODTRANSACAO);
                  }
                });
              }}
              checked={transactionSelected.includes(operacao.CODTRANSACAO)}
            />
          ),
          align: 'center',
          isCheckBox: true,
        },
        { info: operacao.DATAHORA, align: 'center' },
        {
          info: operacao.TIPO,
          align: 'left',
        },
        {
          info: operacao.DESCRICAO,
          align: 'left',
        },
        { info: `R$ ${formatMoney(operacao.VALOR)}`, align: 'right' },
        {
          info: `R$ ${formatMoney(operacao.SALDO_ANTERIOR)}`,
          align: 'right',
        },
        { info: `R$ ${formatMoney(operacao.SALDO_ATUAL)}`, align: 'right' },
        {
          info: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
              }}
            >
              <Tooltip title="Comprovante">
                <div>
                  <Comprovante
                    onClick={(e) => {
                      dispatch(
                        exportReceipt({
                          ID: operacao.CODTRANSACAO,
                          ACAO: 'download',
                        }),
                      );
                    }}
                  />
                </div>
              </Tooltip>
              <Tooltip title={operacao.REPASSADO ? 'Já repassado' : operacao.TIPO === 'DEBITO' ? 'Débito não pode ser repassado' : 'Transferência Administrativa'}>
                <div>
                  <TransferenciaAdmin
                    onClick={(e) => {
                      if (operacao.REPASSADO || operacao.TIPO === 'DEBITO') return;
                      dispatch(detailAccountsFetchAction(contas?.ID_CONTA));
                      setValorTransacao(`R$ ${formatMoney(operacao.VALOR)}`);
                      setDescricaoTransacao(operacao.DESCRICAO);
                      setTransacaoId(operacao.CODTRANSACAO);
                      setMakeTransfer(true);
                      setIsRepasse(true);
                    }}
                    style={{ opacity: operacao.REPASSADO || operacao.TIPO === 'DEBITO' ? 0.3 : 1, cursor: operacao.REPASSADO || operacao.TIPO === 'DEBITO' ? 'not-allowed' : 'pointer' }}
                  />
                </div>
              </Tooltip>
            </div>
          ),
          align: 'center',
        },
      ],
    };
  });

  useEffect(async () => {
    if (showComprovante) {
      const response = await getTicketTransactionAdmin(transactionSelected);
      setFile(response);
    }
  }, [showComprovante]);

  const getTicketTransactionAdmin = async () => {
    try {
      setLoadingComprovante(true);
      const response = await api.get(`/admin/conta/transacao/historico_transacoes_PJ_lote/detalhe/`, {
        params: {
          transactionsId: transactionSelected,
        },
        responseType: 'blob',
      });

      return URL.createObjectURL(response.data);
    } catch (error) {
      showAlert({
        title: 'Ops...',
        text: 'Não foi possível gerar o ticket.',
        icon: 'error',
      });
    } finally {
      setLoadingComprovante(false);
    }
  };

  useMemo(() => {
    if (contas?.ID_CONTA !== undefined) {
      dispatch(
        balanceAccountsFetchAction(contas.ID_CONTA, (res) => {
          setSaldo(res.saldo);
        }),
      );
    }
  }, [contas?.ID_CONTA, loadingUserBalance]);

  const handleChangeSelectAll = (event) => {
    if (event.target.checked) {
      const allTransactionIds = HISTORICO?.data?.map((operacao) => operacao.CODTRANSACAO) || [];
      setTransactionSelected(allTransactionIds);
    } else {
      setTransactionSelected([]);
    }
  };

  const verifyIfAllTransactionsAreSelected = () => {
    const allTransactionIds = HISTORICO?.data?.map((operacao) => operacao.CODTRANSACAO) || [];
    return allTransactionIds.length > 0 && transactionSelected.length === allTransactionIds.length;
  }

  const valorTotal = useMemo(() => {
    return (
      HISTORICO?.data
        ?.filter((op) => transactionSelected.includes(op.CODTRANSACAO))
        ?.reduce((acc, op) => acc + Number(op.VALOR), 0) ?? 0
    );
  }, [transactionSelected, HISTORICO]);

  return (
    <>
      <Styled.GraphicSheetContainer>
        <>
          <Styled.FirstLine>
            <h2>Extrato</h2>
            <Styled.BalanceInfo>
              <img src={dotPrimary} /> <h4>Saldo Atual:</h4>
              <h3>R$ {formatMoney(saldo)}</h3>
            </Styled.BalanceInfo>
          </Styled.FirstLine>
          <Filter>
            <form onSubmit={handleSubmit(filterTable)}>
              <FirstFilterLine width={'50vw'}>
                <DateInput
                  label="Data Inicial"
                  name={'DATA_INICIAL'}
                  control={control}
                  value={dateInicial}
                  onChange={(newValue) =>
                    newValue?.$d ? setDateInicial(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateInicial(null)
                  }
                />
                <DateInput
                  label="Data Final"
                  name={'DATA_FINAL'}
                  control={control}
                  value={dateFinal}
                  onChange={(newValue) =>
                    newValue?.$d ? setDateFinal(moment(newValue?.$d).format('YYYY-MM-DD')) : setDateFinal(null)
                  }
                />
                <Button
                  backgroundcolor={theme.colors.buttonSearch}
                  width="12.153vw"
                  height="3.333vw"
                  hoverbgcolor={theme.colors.buttonSearchHover}
                  hovercolor={theme.colors.buttonSearchHoverText}
                  mycolor={theme.colors.buttonSearchText}
                  type="submit"
                >
                  <ImSearch className="default-svg" size={'1.181vw'} />
                  <span>Buscar</span>
                </Button>
              </FirstFilterLine>
              <SecondFilterLine>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <Box>
                    <Checkbox
                      onChange={(event) => handleChangeSelectAll(event)}
                      checked={verifyIfAllTransactionsAreSelected()}
                    />
                    <span>Selecionar todos</span>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {transactionSelected.length > 0 && (
                      <Button
                        variant="outlined"
                        onClick={() => {
                          dispatch(detailAccountsFetchAction(contas?.ID_CONTA));
                          setRepaseLote(true);
                          setIsRepasse(true);
                        }}
                      >
                        Repasse em lote
                      </Button>
                    )}
                    {transactionSelected.length > 0 && (
                      <Button onClick={() => setShowComprovante(true)}>Baixar comprovante</Button>
                    )}
                    <h5>Resultados por página</h5>
                    <SelectOptions
                      control={control}
                      options={pagesOptions}
                      name={'LIMIT'}
                      width={'4vw'}
                      initialValue={10}
                    />
                    <h5>Total de Resultados: {HISTORICO?.pagination?.totalResult}</h5>
                  </Box>
                </Box>
              </SecondFilterLine>
            </form>
          </Filter>

          {loadingUserBalance ? (
            <Loading />
          ) : (
            <Table
              loading={loadingUserBalance}
              error={errorUserBalance}
              header={header}
              body={body}
              filter={filterData}
              setFilter={setFilterData}
              hasPagination={true}
              pagination={HISTORICO?.pagination}
              limit={filterData.LIMIT}
            />
          )}
        </>
      </Styled.GraphicSheetContainer>
      {makeTransfer && (
        <ModalMakeTransfer
          openModal={makeTransfer}
          closeModal={() => {
            setMakeTransfer(false);
            setValorTransacao(null);
            setDescricaoTransacao(null);
            setTransacaoId(null);
            setIsRepasse(false);
          }}
          idConta={contas?.ID_CONTA}
          valorTransacao={valorTransacao}
          descricaoTransacao={descricaoTransacao}
          transacaoId={transacaoId}
          isRepasse={isRepasse}
        />
      )}
      {repaseLote && (
        <RepaseLote
          openModal={repaseLote}
          closeModal={() => {
            setRepaseLote(false);
            setTransactionSelected([]);
            setIsRepasse(false);
          }}
          idConta={contas?.ID_CONTA}
          transactionIds={transactionSelected}
          valorTotal={valorTotal}
        />
      )}
      {showComprovante && (
        <Modal open={showComprovante} close={() => setShowComprovante(false)} title={'Comprovante'} width={'1000px'}>
          <>
            {lodingComprovante ? (
              <Skeleton variant="rounded" width={'550px'} height={350} />
            ) : (
              <iframe title="a;ksjdaklsdjhlk" src={file} width="100%" height="800px" style={{ border: 'none' }} />
            )}
          </>
        </Modal>
      )}
    </>
  );
}
